import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {SalesAuditReportModel} from "./sales-audit-report-model.service";
import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";

@Component({
    selector: "wbo-sales-audit-report",
    templateUrl: "./sales-audit-report.component.html",
    providers: [provideReportModel(SalesAuditReportModel)]
})
export class SalesAuditReportComponent extends AbstractReportPage {

    constructor(public model: SalesAuditReportModel) {
        super();
    }
}
